import { useEffect, useState } from "react";

export function usePersistedState(key, initial, { parse = (v) => v, serialize = (v) => v } = {}) {
  const [v, setV] = useState(() => {
    try { const raw = sessionStorage.getItem(`pg_ui_${key}`); return raw != null ? parse(JSON.parse(raw)) : initial; } catch { return initial; }
  });
  useEffect(() => { try { sessionStorage.setItem(`pg_ui_${key}`, JSON.stringify(serialize(v))); } catch {} }, [key, v]); // eslint-disable-line
  return [v, setV];
}

export const canGoBack = () => (window.history.state?.idx ?? 0) > 0;

const paths = { prev: null, cur: null };
export const trackPath = (p) => { if (p !== paths.cur) { paths.prev = paths.cur; paths.cur = p; } };
export const prevPath = () => paths.prev;

const scrollKey = () => `pg_scroll_${window.location.pathname}`;
export const forgetScroll = () => { try { Object.keys(sessionStorage).filter((k) => k.startsWith("pg_scroll_")).forEach((k) => sessionStorage.removeItem(k)); } catch {} };

/** Remembers the window scroll position of a list page and restores it once the list data is on screen (back button or in-app Back). */
export function useScrollMemory(ready) {
  useEffect(() => {
    const key = scrollKey();
    let t;
    const onScroll = () => { clearTimeout(t); t = setTimeout(() => { try { sessionStorage.setItem(key, String(window.scrollY)); } catch {} }, 80); };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); clearTimeout(t); };
  }, []);
  useEffect(() => {
    if (!ready) return;
    const y = Number(sessionStorage.getItem(scrollKey()) || 0);
    if (!y) return;
    let tries = 0;
    const go = () => { window.scrollTo(0, y); if (Math.abs(window.scrollY - y) > 2 && tries++ < 10) requestAnimationFrame(go); };
    requestAnimationFrame(go);
  }, [ready]); // eslint-disable-line
}

